import { Component } from '@angular/core';

@Component({
  selector: 'app-typing-loader',
  imports: [],
  template: `<div class="typing-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>`,
  styleUrl: './typing-loader.scss',
})
export class TypingLoader {}
